export default __webpack_public_path__ + "static/media/consumo.db04378f.png";